import { render, staticRenderFns } from "./ListEmpty.vue?vue&type=template&id=1cf35004"
import script from "./ListEmpty.vue?vue&type=script&lang=js"
export * from "./ListEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf35004')) {
      api.createRecord('1cf35004', component.options)
    } else {
      api.reload('1cf35004', component.options)
    }
    module.hot.accept("./ListEmpty.vue?vue&type=template&id=1cf35004", function () {
      api.rerender('1cf35004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Folder/ListEmpty.vue"
export default component.exports